import {DomainTroubleshoot} from "./domain-troubleshoot";

export class DomainTroubleshootMapper {

  public static map(data: any, domainId: number): DomainTroubleshoot {
    const domainTroubleshoot: DomainTroubleshoot = new DomainTroubleshoot();
    domainTroubleshoot.ssl = data.troubleshoot_result[domainId].has_certificate;
    domainTroubleshoot.pointed = data.troubleshoot_result[domainId].domain_pointed;
    domainTroubleshoot.server = data.troubleshoot_result[domainId].server;
    return domainTroubleshoot;
  }

}
